// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1annu","label":"Category_label__2hz5v","content":"Category_content__vQbXI","header":"Category_header__1cwU1","location":"Category_location__3PwvZ"};